import { PacingBlockV2 } from 'shared/src/api/line-item-types';
import type { ISODateRange, ISODateString } from 'shared/src/date-string-utils/types';
import { addDays, isBefore } from 'shared/src/date-string-utils/date-utils';

export type Day = { day: ISODateString; cumulativeTotal: number };

export function getUncoveredDateRangesV2(
  blocks: PacingBlockV2[],
  lineItemStart: ISODateString,
  lineItemEnd: ISODateString
): ISODateRange[] {
  if (blocks.length === 0) {
    return [{ from: lineItemStart, to: lineItemEnd }];
  }

  const sortedBlocks = [...blocks].sort((a, b) => a.dates.from.localeCompare(b.dates.from));
  const uncoveredRanges: ISODateRange[] = [];

  if (isBefore(lineItemStart, sortedBlocks[0].dates.from)) {
    uncoveredRanges.push({
      from: lineItemStart,
      to: addDays(sortedBlocks[0].dates.from, -1)
    });
  }

  for (let i = 0; i < sortedBlocks.length - 1; i++) {
    const currentEnd = sortedBlocks[i].dates.to;
    const nextStart = sortedBlocks[i + 1].dates.from;

    if (isBefore(currentEnd, addDays(nextStart, -1))) {
      uncoveredRanges.push({
        from: addDays(currentEnd, 1),
        to: addDays(nextStart, -1)
      });
    }
  }

  const lastBlock = sortedBlocks[sortedBlocks.length - 1];
  if (isBefore(lastBlock.dates.to, lineItemEnd)) {
    uncoveredRanges.push({
      from: addDays(lastBlock.dates.to, 1),
      to: lineItemEnd
    });
  }

  return uncoveredRanges;
}
